@if (loaderService.isLoading$ | async) {
  <div
    class="fixed inset-0 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm z-50 transition-all duration-500 ease-in-out"
    >
    <img
      src="assets/animations/mochila.gif"
      alt="Cargando..."
      class="w-auto h-auto max-w-full max-h-full"
      />
    </div>
  }
